import React, { FC, useEffect } from 'react'
import Layout from '../components/layout/Layout'
import DashboardSwitch from '../components/dashboard/DashboardSwitch'
import { MsalAuthenticationTemplate, useMsal } from '@azure/msal-react'
import { AuthError, InteractionRequiredAuthError, InteractionType } from '@azure/msal-browser'
import { loginRequest } from '../services/AuthConfig'
import { portalUrl } from '../services/http-common'

const Dashboard: FC = () => {
  const { instance } = useMsal()
  useEffect(() => {
    console.log(instance.getActiveAccount())
    console.log(instance.getAllAccounts())
  }, [instance])
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Silent}
      authenticationRequest={{ ...loginRequest, account: instance.getActiveAccount() ?? undefined }}
      errorComponent={ErrorComponent}
    >
      <Layout>
        <DashboardSwitch />
      </Layout>
    </MsalAuthenticationTemplate>
  )
}

export const ErrorComponent: FC<{ error: AuthError | null }> = ({ error }) => {
  useEffect(() => {
    if (error instanceof InteractionRequiredAuthError) {
      window.location.replace(`${portalUrl}?app=${encodeURIComponent(window.location.href)}`)
    }
  }, [error])
  return null
}

export default Dashboard
